// src/components/DispenserGuard.jsx
import { Navigate } from "react-router-dom";
import { useConfig } from "../context/configContext";

const DispenserGuard = ({ children }) => {
  const { config } = useConfig();

  if (config.dispensers <= 0) {
    return <Navigate to="/maps" replace />;
  }

  return children;
};

export default DispenserGuard;
